import axios from "axios";

// api: public calls (login, /refresh, logout). apiPrivate: authenticated calls, with the cookie;
// useApiInterceptors attaches the token, the refresh on TOKEN_EXPIRED and the error handling to it.
const createApiClients = (baseURL) => ({
  api: axios.create({
    baseURL,
    headers: { "Content-Type": "application/json" },
  }),
  apiPrivate: axios.create({
    baseURL,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  }),
});

export default createApiClients;
